import i from './sppb.container';

export default i;
